import { Container, CssBaseline } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AppContext from "../../config/AppContext";
import i18n from "../../config/i18n";
import { getUserPreferences } from "../../services/DashboardService";
import { getUserById, listUserCompanies } from "../../services/MemberService";
import { getloggedCompanySubscription } from "../../services/Subscription";
import CommonUtil from "../../util/CommonUtils";
import { sidebarContext } from "../../util/context";
import FlowiseEmbedReact from "../FlowiseEmbedReact";
import "./LayoutComponents.scss";
import NavMenu from "./NavMenu";

export default function HomeLayout(props) {
  const [expand, setExpand] = useState(false);
  const [enableAi, setEnableAi] = useState(true);
  const [enableAiPredictions, setEnableAiPredictions] = useState(false);
  const [userPreferences, setUserPreferences] = useState(undefined);
  const [profilePic, setProfilePic] = useState(undefined);
  const { colorMode, mode } = useContext(AppContext);
  const [userProfile, setUserProfile] = useState(undefined);
  const [companyProfile, setCompanyProfile] = useState(undefined);
  const [isUserAuthenticated, setUserAuthenticated] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [subscriptionDetails, setSubscriptionDetails] = useState([]);

  const navigate = useNavigate();
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     const element = document.getElementById("dify-chatbot-bubble-button");
  //     if (element) {
  //       element.style.height = "50px";
  //       element.style.width = "50px";
  //       clearInterval(interval); // Stop checking once it's found and updated
  //     }
  //   }, 100); // Check every 100ms

  //   // Optional: Cleanup on unmount
  //   return () => clearInterval(interval);
  // }, []);

  useEffect(() => {
    const element = document.getElementById(
      "6f99dc7d-3b52-442b-9941-76cf3b7aff95"
    );
    if (element) {
      element.style.display = "inline";
    }
  }, []);

  useEffect(() => {
    if (CommonUtil.isEmptyString(localStorage.getItem("token"))) {
      navigate("/");
    } else {
      setUserAuthenticated(true);
    }
    const decoded = CommonUtil.decodeToken();
    const userData = localStorage.getItem("USER");
    console.log("User Data in Local Storage: ", decoded); // Check if user data is stored correctly

    if (userData) {
      const user = JSON.parse(userData);
      const userId = user.userId;
      const companyId = user.companyId;

      if (userId && companyId) {
        getUserById(userId)
          .then((response) => {
            if (response.data && response.data.data) {
              const pic = response.data.data.profilePhoto;
              setUserProfile(response.data.data);
              if (pic) {
                setProfilePic(pic);
              }
            }
          })
          .catch((error) => {
            console.log("Error fetching user details: " + error.message);
          });

        getUserPreferences(userId)
          .then((response) => {
            if (response.data && response.data.data) {
              let broswerLanguage =
                navigator.language || navigator.userLanguage;
              const darkMode = window.matchMedia(
                "(prefers-color-scheme: dark)"
              ).matches;
              const { aiAssistEnabled, language, theme } = response.data.data;
              setUserPreferences(response.data.data);

              if (language !== "SYSTEM") {
                const lang = !["en", "zh", "es", "ja", "ko"].includes(
                  language?.toLowerCase()
                )
                  ? "en"
                  : language?.toLowerCase();
                CommonUtil.changeLanguage(lang);
                i18n.changeLanguage(lang);
              } else {
                if (broswerLanguage.includes("-")) {
                  broswerLanguage = broswerLanguage.split("-")[0];
                }
                const lang = ["en", "es", "zh", "ja", "ko"].includes(
                  broswerLanguage
                )
                  ? broswerLanguage
                  : "en";
                CommonUtil.changeLanguage(lang);
                i18n.changeLanguage(lang);
              }

              if (theme !== "SYSTEM") {
                colorMode.toggleColorMode(
                  !["dark", "light"].includes(theme?.toLowerCase())
                    ? "light"
                    : theme?.toLowerCase()
                );
              } else {
                colorMode.toggleColorMode(darkMode ? "dark" : "light");
              }

              // setEnableAi(aiAssistEnabled);
            }
          })
          .catch((error) => {
            console.log("Error fetching user preferences: " + error.message);
          });

        listUserCompanies({ pageNumber: 1, pageSize: 1000 })
          .then((res) => {
            if (
              res.data?.code === "UASI0029" &&
              Array.isArray(res.data?.data?.companies)
            ) {
              const companiesList = res.data?.data?.companies;
              setCompanies(companiesList);
              const currentCompany = companiesList.find(
                (company) => company.id === companyId
              );
              if (currentCompany) {
                setCompanyProfile(currentCompany?.name);
              }
            }
          })
          .catch((error) => {
            console.log("Error fetching companies: " + error.message);
          });
      } else {
        console.log("No user ID or company ID found in user data.");
      }
      getSubscriptionDetails();
    } else {
      console.log("No user data found in local storage.");
    }
  }, []);

  const getSubscriptionDetails = () => {
    getloggedCompanySubscription()
      .then((res) => {
        if (res.data?.code === "RCI0000") {
          const subscription = res.data?.data;
          setSubscriptionDetails(subscription);
          if (subscription && typeof subscription === "object") {
            const feature = subscription?.features?.find(
              (feature) => feature?.feature?.code === "TIMESHEET"
            );
            const value = feature?.value;
            if (value === "All" || value === "Automatic Project Tagging") {
              setEnableAiPredictions(true);
            }
          }
        }
      })
      .catch((error) => {
        console.log("Error fetching subscription: " + error.message);
      });
  };

  return !isUserAuthenticated ? (
    <></>
  ) : (
    <sidebarContext.Provider
      value={{
        expand,
        setExpand,
        enableAi,
        setEnableAi,
        enableAiPredictions,
        setEnableAiPredictions,
        userProfile,
        setUserProfile,
        profilePic,
        setProfilePic,
        companyProfile,
        setCompanyProfile,
        userPreferences,
        setUserPreferences,
        subscriptionDetails,
        setSubscriptionDetails,
      }}
    >
      <CssBaseline />
      <Container
        maxWidth={false}
        disableGutters
        style={{
          height: "100vh",
        }}
      >
        <div
          style={{
            position: "relative",
            height: "100%",
            width: "100%",
          }}
        >
          <div
            style={{
              position: "absolute",
              height: "100%",
              width: "100%",
            }}
          >
            <div style={{ display: "flex", height: "100%" }}>
              <FlowiseEmbedReact />
              {/* <VoiceWidget /> */}
              <NavMenu />
              <div className="main-body">{props.children}</div>
            </div>
          </div>
        </div>
      </Container>
    </sidebarContext.Provider>
  );
}
